import AnimatedUploadingFilePopUp from './AnimatedUploadingFilePopUp';

export default AnimatedUploadingFilePopUp;
